var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.765.772a5.56 5.56 0 00-2.48.53 12.4 12.4 0 00-1.38.88 9.28 9.28 0 00-2.3 2.25 6.89 6.89 0 00-1.38 4.33 9.37 9.37 0 001.59 4.23c.54.79 1.84 0 1.29-.76a8.21 8.21 0 01-1.38-3.47 5.64 5.64 0 011.17-3.58 7.56 7.56 0 011.25-1.28l.35-.3c.14-.12-.1.07 0 0l.15-.1a12 12 0 011.12-.74 4 4 0 012-.47.75.75 0 000-1.5v-.02z",
    fill: "#BDACBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.935 13.142a9.059 9.059 0 004.15 2.43 7.11 7.11 0 004.82-.46 7.46 7.46 0 004.41-7.38c-.07-1-1.57-1-1.5 0a6 6 0 01-3.49 6 5.62 5.62 0 01-3.95.35 7.64 7.64 0 01-3.38-2c-.65-.72-1.71.34-1.06 1.06z",
    fill: "#BDACBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.185 15.252a7.52 7.52 0 006.68-11.11 7.59 7.59 0 00-5.86-3.88 5.82 5.82 0 00-3.53.61c-.631.347-1.224.76-1.77 1.23a8.5 8.5 0 00-2.49 3.26 6 6 0 00-.34 4.07.75.75 0 001.45-.39 4.38 4.38 0 01.18-2.88 6.49 6.49 0 011.8-2.59c.335-.308.69-.596 1.06-.86a4.67 4.67 0 012.46-1 6.003 6.003 0 01.36 12 .75.75 0 100 1.5v.04z",
    fill: "#BDACBB"
  })));
}
export default SvgConnections;